module.exports = "/_next/static/media/101bb8e27ac4ab1d45c17bf5799e38b0.svg";